import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export function useFormatHours(date: Date) {
  return format(new Date(date), 'HH:mm')
}

export function useFormatDate(date: Date) {
  return format(new Date(date), 'dd/MM/yyyy')
}

export function useFormatDateWithoutYear(date: Date) {
  return format(new Date(date), 'dd/MM')
}

export function useFormatDateToInput(date: Date) {
  return format(new Date(date), 'yyyy-MM-dd')
}

/** Helpers legados para gráficos ApexCharts com eixo UTC; para novos fluxos prefira parseUTCFromAPI*. */
export function convertToLocalTime(utcTime: Date | string | number) {
  const utcDate = parseUTCFromAPI(utcTime)
  return new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000)
}

export function convertToLocalTimeUnix(utcTime: Date | string | number): number {
  const utcDate = parseUTCFromAPI(utcTime)
  return utcDate.getTime() - utcDate.getTimezoneOffset() * 60000
}

/**
 * Interpreta valor da API (sempre UTC 0) como instante correto.
 * Não aplica offset: Date já exibe em horário local ao formatar; ECharts usa o timestamp e exibe em local.
 * Use para start_date, end_date e timestamps (t) no módulo de registros.
 */
export function parseUTCFromAPI(apiValue: Date | string | number): Date {
  if (apiValue instanceof Date) {
    return new Date(apiValue.getTime())
  }
  if (typeof apiValue === 'number') {
    return new Date(apiValue)
  }
  if (typeof apiValue !== 'string') {
    return new Date(NaN)
  }
  const s = apiValue.trim()
  if (!s) return new Date(NaN)
  const asUTC = /Z|[+-]\d{2}:?\d{2}$/.test(s) ? s : `${s.replace(/\s*$/, '')}Z`
  return new Date(asUTC)
}

/** Timestamp em ms (instante UTC) para eixo de tempo. ECharts exibe em fuso local. */
export function parseUTCFromAPIToUnix(apiValue: string | number): number {
  return parseUTCFromAPI(apiValue).getTime()
}

export function convertToLocalTimeUnix2(timestamp: number): Date {
  const utcDate = new Date(timestamp)
  return new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000)
}

export function useFormatDateTimeLabel(date: Date) {
  return format(date, 'dd/MM/yyyy, HH:mm')
}

export function useFormatDateTime(date: Date) {
  const formattedDate = useFormatDate(date)
  const formattedTime = useFormatHours(date)

  return `${formattedDate} | ${formattedTime}`
}

export function convertToUTCUnix(localTime: Date | string): number {
  const localDate = new Date(localTime)
  return localDate.getTime() + localDate.getTimezoneOffset() * 60000
}

export function useFormatDateToText(date: Date) {
  return format(new Date(date), 'EEE, dd MMM', { locale: ptBR })
}

export function useFormatDateTimeISO(date: Date) {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss")
}

export function formatHoursToHM(timeInHours: number | null | undefined): string {
  if (timeInHours == null || timeInHours < 0) {
    return '0h 0m'
  }

  const hours = Math.floor(timeInHours)
  const minutes = Math.round((timeInHours - hours) * 60)

  return `${hours}h ${minutes}m`
}
